/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSourceAccessor
 */
export interface MessageSourceAccessor {
    /**
     * 
     * @type {object}
     * @memberof MessageSourceAccessor
     */
    messageSource?: object;
    /**
     * 
     * @type {object}
     * @memberof MessageSourceAccessor
     */
    defaultLocale?: object;
}

/**
 * Check if a given object implements the MessageSourceAccessor interface.
 */
export function instanceOfMessageSourceAccessor(value: object): value is MessageSourceAccessor {
    return true;
}

export function MessageSourceAccessorFromJSON(json: any): MessageSourceAccessor {
    return MessageSourceAccessorFromJSONTyped(json, false);
}

export function MessageSourceAccessorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSourceAccessor {
    if (json == null) {
        return json;
    }
    return {
        
        'messageSource': json['messageSource'] == null ? undefined : json['messageSource'],
        'defaultLocale': json['defaultLocale'] == null ? undefined : json['defaultLocale'],
    };
}

export function MessageSourceAccessorToJSON(json: any): MessageSourceAccessor {
    return MessageSourceAccessorToJSONTyped(json, false);
}

export function MessageSourceAccessorToJSONTyped(value?: MessageSourceAccessor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'messageSource': value['messageSource'],
        'defaultLocale': value['defaultLocale'],
    };
}

